import { Typography } from '@material-ui/core'
import parse from 'html-react-parser'

import { stripHtmlTags } from '../../../../helpers/stripHTML'
import { getTranslate, lang } from '../../../../localization'
import { CartItem } from '../../../../types/cart'
import { useStyles } from './styles/index.styles'

// export function getCancelPolicyContent(cartItem?: CartItem) {
//   const classes = useStyles()
//   if (!cartItem?.cancellationPolicy) return null

//   if (cartItem.cancellationPolicy.description) {
//     return cartItem.cancellationPolicy.description
//   }

//   return cartItem.cancellationPolicy.policies
//     .map((item, i) => {
//       let policyText = ''
//       let timeUnit = ''

//       switch (item.policyType) {
//         case 'ReservationTime':
//           policyText = getTranslate('after reservation time:')
//           break
//         case 'CheckInTime':
//           policyText = getTranslate('before the arrival time:')
//           break
//         case 'AfterCheckInTime':
//           policyText = getTranslate('after check-in time:')
//           break
//         case 'BeforeCheckOutTime':
//           policyText = getTranslate('before checkout time:')
//           break
//         default:
//           return null
//       }

//       if (item.deadline % 24 === 0) {
//         timeUnit =
//           item.deadline / 24 !== 1 ? getTranslate('days') : getTranslate('day')
//       } else {
//         timeUnit =
//           item.deadline !== 1 ? getTranslate('hours') : getTranslate('hour')
//       }

//       const deadlineValue =
//         item.deadline % 24 === 0 ? item.deadline / 24 : item.deadline

//       return lang === 'en' ? (
//         <div key={item.deadline + i.toString() + item.deadline}>
//           <Typography variant="h6" className={classes.dotText}>
//             {`${getTranslate('Less than')} ${Math.floor(
//               deadlineValue
//             )} ${timeUnit} ${policyText}`}
//           </Typography>
//           <Typography variant="h6">
//             {item.penaltyAmount}
//             {getTranslate('% of the')}{' '}
//             {item.penaltyType === 'FirstNight'
//               ? getTranslate('first night price')
//               : getTranslate('total price')}{' '}
//             {getTranslate('will be charged.')}
//           </Typography>
//         </div>
//       ) : (
//         <div key={item.deadline + i.toString() + item.deadline}>
//           <div className={classes.mainDeadLineText}>
//             <div>{policyText}</div>&nbsp;
//             {`${getTranslate('Less than')} ${Math.floor(
//               deadlineValue
//             )} ${timeUnit}`}
//           </div>
//           <span className={classes.deadLineTextContainer}>
//             {item.penaltyType === 'FirstNight'
//               ? getTranslate('first night price.')
//               : getTranslate('total price.')}{' '}
//             {getTranslate('will be charged')} &nbsp;
//             <div>{getTranslate('of the')}&nbsp;</div>
//             {item.penaltyAmount} %
//           </span>
//         </div>
//       )
//     })
//     .filter(Boolean)
// }
// export function ToolTipContentForCancelPolicy({
//   cartItem
// }: {
//   cartItem?: CartItem
// }) {
//   const classes = useStyles()
//   const cancelPolicyText = getCancelPolicyContent(cartItem)

//   if (
//     !cancelPolicyText ||
//     (Array.isArray(cancelPolicyText) && cancelPolicyText.length === 0)
//   ) {
//     return null
//   }

//   return (
//     <div className={classes.main}>
//       <div className={classes.headerToolTip}>
//         <Typography variant="h5" className={classes.toolTipText}>
//           {getTranslate('Cancellation Policy')}
//         </Typography>
//       </div>
//       <div className={classes.content}>{cancelPolicyText}</div>
//     </div>
//   )
// }

// export function getModifyPolicyContent(cartItem?: CartItem) {
//   const classes = useStyles()
//   if (!cartItem?.modificationPolicy) return null

//   if (cartItem.modificationPolicy.description) {
//     return cartItem.modificationPolicy.description
//   }

//   return cartItem.modificationPolicy.policies
//     .map((item, i) => {
//       const somethingToShow = item.deadline <= 4320
//       if (somethingToShow) {
//         let policyText = ''
//         let timeUnit = ''

//         switch (item.policyType) {
//           case 'AfterReservationTime':
//             policyText = getTranslate('after reservation time:')
//             break
//           case 'BeforeCheckInTime':
//             policyText = getTranslate('before the arrival time:')
//             break
//           case 'AfterCheckInTime':
//             policyText = getTranslate('after check-in time:')
//             break
//           case 'BeforeCheckOutTime':
//             policyText = getTranslate('before checkout time:')
//             break
//           default:
//             return null
//         }

//         if (item.deadline % 24 === 0) {
//           timeUnit =
//             item.deadline / 24 !== 1
//               ? getTranslate('days')
//               : getTranslate('day')
//         } else {
//           timeUnit =
//             item.deadline !== 1 ? getTranslate('hours') : getTranslate('hour')
//         }

//         return lang === 'en' ? (
//           <div key={item.deadline + i.toString() + item.deadline}>
//             {`${getTranslate('Less than')} ${Math.floor(
//               item.deadline / 24 === 0 ? item.deadline : item.deadline / 24
//             )} ${timeUnit} ${policyText}`}
//             <br />
//             <span>
//               {item.penaltyAmount}
//               {getTranslate('% of the')}{' '}
//               {item.penaltyType === 'FirstNight'
//                 ? getTranslate('first night price')
//                 : getTranslate('total price')}{' '}
//               {getTranslate('will be charged.')}
//             </span>
//           </div>
//         ) : (
//           <div key={item.deadline + i.toString() + item.deadline}>
//             <div className={classes.mainDeadLineText}>
//               <div>{policyText}</div>&nbsp;
//               {`${getTranslate('Less than')} ${Math.floor(
//                 item.deadline / 24 === 0 ? item.deadline : item.deadline / 24
//               )} ${' '} ${timeUnit}`}
//             </div>
//             <span className={classes.deadLineTextContainer}>
//               {item.penaltyType === 'FirstNight'
//                 ? getTranslate('first night price.')
//                 : getTranslate('total price.')}{' '}
//               {getTranslate('will be charged')} &nbsp;
//               <div>{getTranslate('of the')}&nbsp;</div>
//               {item.penaltyAmount} %
//             </span>
//           </div>
//         )
//       } else {
//         return null
//       }
//     })
//     .filter(Boolean)
// }
// export function ToolTipContentForModifyPolicy({
//   cartItem
// }: {
//   cartItem?: CartItem
// }) {
//   const classes = useStyles()
//   const modifyPolicyText = getModifyPolicyContent(cartItem)

//   if (
//     !modifyPolicyText ||
//     (Array.isArray(modifyPolicyText) && modifyPolicyText.length === 0)
//   ) {
//     return null
//   }

//   return (
//     <div className={classes.main}>
//       <div className={classes.headerToolTip}>
//         <Typography variant="h5" className={classes.toolTipText}>
//           {getTranslate('Modify Policy')}
//         </Typography>
//       </div>
//       <div className={classes.content}>{modifyPolicyText}</div>
//     </div>
//   )
// }
export function getCancelPolicyContent(cartItem?: CartItem) {
  const classes = useStyles()
  if (!cartItem?.cancellationPolicy) return null

  if (cartItem.cancellationPolicy.description) {
    return parse(
      stripHtmlTags(cartItem.cancellationPolicy.description).replace(
        /\n/g,
        '<br/>'
      )
    )
  }

  return cartItem.cancellationPolicy.policies
    .map((item, i) => {
      let policyText = ''
      let timeUnit = ''

      switch (item.policyType) {
        case 'ReservationTime':
          policyText = getTranslate('after reservation time:')
          break
        case 'CheckInTime':
          policyText = getTranslate('before the arrival time:')
          break
        case 'AfterCheckInTime':
          policyText = getTranslate('after check-in time:')
          break
        case 'BeforeCheckOutTime':
          policyText = getTranslate('before checkout time:')
          break
        default:
          return null
      }

      if (item.deadline % 24 === 0) {
        timeUnit =
          item.deadline / 24 !== 1 ? getTranslate('days') : getTranslate('day')
      } else {
        timeUnit =
          item.deadline !== 1 ? getTranslate('hours') : getTranslate('hour')
      }

      const deadlineValue =
        item.deadline % 24 === 0 ? item.deadline / 24 : item.deadline

      return lang === 'en' ? (
        <div key={item.deadline + i.toString() + item.deadline}>
          <Typography variant="h6" className={classes.dotText}>
            {`${getTranslate('Less than')} ${Math.floor(
              deadlineValue
            )} ${timeUnit} ${policyText}`}
          </Typography>
          <Typography variant="h6">
            {item.penaltyAmount}
            {getTranslate('% of the')}{' '}
            {item.penaltyType === 'FirstNight'
              ? getTranslate('first night price')
              : getTranslate('total price')}{' '}
            {getTranslate('will be charged.')}
          </Typography>
        </div>
      ) : (
        <div key={item.deadline + i.toString() + item.deadline}>
          <div className={classes.mainDeadLineText}>
            <div>{policyText}</div>&nbsp;
            {`${getTranslate('Less than')} ${Math.floor(
              deadlineValue
            )} ${timeUnit}`}
          </div>
          <span className={classes.deadLineTextContainer}>
            {item.penaltyType === 'FirstNight'
              ? getTranslate('first night price.')
              : getTranslate('total price.')}{' '}
            {getTranslate('will be charged')} &nbsp;
            <div>{getTranslate('of the')}&nbsp;</div>
            {item.penaltyAmount} %
          </span>
        </div>
      )
    })
    .filter(Boolean)
}
export function ToolTipContentForCancelPolicy({
  cartItem
}: {
  cartItem?: CartItem
}) {
  const classes = useStyles()
  const cancelPolicyText = getCancelPolicyContent(cartItem)

  if (
    !cancelPolicyText ||
    (Array.isArray(cancelPolicyText) && cancelPolicyText.length === 0)
  ) {
    return null
  }

  return (
    <div className={classes.main}>
      <div className={classes.headerToolTip}>
        <Typography variant="h5" className={classes.toolTipText}>
          {getTranslate('Cancellation Policy')}
        </Typography>
      </div>
      <div
        className={classes.content}
        style={{
          direction: lang === 'fa' ? 'rtl' : 'ltr', // make layout direction dynamic
          textAlign: lang === 'fa' ? 'right' : 'left', // align text accordingly
          whiteSpace: 'pre-line', // keep newlines from stripHtmlTags
          unicodeBidi: 'embed' // handle mixed RTL/LTR properly
        }}>
        {cancelPolicyText}
      </div>
    </div>
  )
}

export function getModifyPolicyContent(cartItem?: CartItem) {
  const classes = useStyles()
  if (!cartItem?.modificationPolicy) return null

  if (cartItem.modificationPolicy.description) {
    return parse(
      stripHtmlTags(cartItem.modificationPolicy.description).replace(
        /\n/g,
        '<br/>'
      )
    )
  }

  return cartItem.modificationPolicy.policies
    .map((item, i) => {
      const somethingToShow = item.deadline <= 4320
      if (somethingToShow) {
        let policyText = ''
        let timeUnit = ''

        switch (item.policyType) {
          case 'AfterReservationTime':
            policyText = getTranslate('after reservation time:')
            break
          case 'BeforeCheckInTime':
            policyText = getTranslate('before the arrival time:')
            break
          case 'AfterCheckInTime':
            policyText = getTranslate('after check-in time:')
            break
          case 'BeforeCheckOutTime':
            policyText = getTranslate('before checkout time:')
            break
          default:
            return null
        }

        if (item.deadline % 24 === 0) {
          timeUnit =
            item.deadline / 24 !== 1
              ? getTranslate('days')
              : getTranslate('day')
        } else {
          timeUnit =
            item.deadline !== 1 ? getTranslate('hours') : getTranslate('hour')
        }

        return lang === 'en' ? (
          <div key={item.deadline + i.toString() + item.deadline}>
            {`${getTranslate('Less than')} ${Math.floor(
              item.deadline / 24 === 0 ? item.deadline : item.deadline / 24
            )} ${timeUnit} ${policyText}`}
            <br />
            <span>
              {item.penaltyAmount}
              {getTranslate('% of the')}{' '}
              {item.penaltyType === 'FirstNight'
                ? getTranslate('first night price')
                : getTranslate('total price')}{' '}
              {getTranslate('will be charged.')}
            </span>
          </div>
        ) : (
          <div key={item.deadline + i.toString() + item.deadline}>
            <div className={classes.mainDeadLineText}>
              <div>{policyText}</div>&nbsp;
              {`${getTranslate('Less than')} ${Math.floor(
                item.deadline / 24 === 0 ? item.deadline : item.deadline / 24
              )} ${' '} ${timeUnit}`}
            </div>
            <span className={classes.deadLineTextContainer}>
              {item.penaltyType === 'FirstNight'
                ? getTranslate('first night price.')
                : getTranslate('total price.')}{' '}
              {getTranslate('will be charged')} &nbsp;
              <div>{getTranslate('of the')}&nbsp;</div>
              {item.penaltyAmount} %
            </span>
          </div>
        )
      } else {
        return null
      }
    })
    .filter(Boolean)
}
export function ToolTipContentForModifyPolicy({
  cartItem
}: {
  cartItem?: CartItem
}) {
  const classes = useStyles()
  const modifyPolicyText = getModifyPolicyContent(cartItem)

  if (
    !modifyPolicyText ||
    (Array.isArray(modifyPolicyText) && modifyPolicyText.length === 0)
  ) {
    return null
  }

  return (
    <div className={classes.main}>
      <div className={classes.headerToolTip}>
        <Typography variant="h5" className={classes.toolTipText}>
          {getTranslate('Modify Policy')}
        </Typography>
      </div>
      <div
        className={classes.content}
        style={{
          direction: lang === 'fa' ? 'rtl' : 'ltr', // make layout direction dynamic
          textAlign: lang === 'fa' ? 'right' : 'left', // align text accordingly
          whiteSpace: 'pre-line', // keep newlines from stripHtmlTags
          unicodeBidi: 'embed' // handle mixed RTL/LTR properly
        }}>
        {modifyPolicyText}
      </div>
    </div>
  )
}
